import React, { useEffect, useState } from 'react';
import { ProfileDashboard } from '@/components/dashboard/ProfileDashboard';
import { useAuth } from '@/components/AuthProvider';
import { Navigate, useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const Dashboard = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    if (user) {
      checkProfileCompletion();
    }
  }, [user]);

  const checkProfileCompletion = async () => {
    try {
      const { data: profile } = await supabase
        .from('profiles')
        .select('first_name, last_name, age')
        .eq('user_id', user.id)
        .single();

      const isProfileComplete = profile?.age && (profile?.first_name || profile?.last_name);
      
      if (!isProfileComplete) {
        navigate('/onboarding', { replace: true });
        return;
      }
      
      setProfileLoading(false);
    } catch (error) {
      console.error('Error checking profile:', error);
      navigate('/onboarding', { replace: true });
    }
  };

  if (loading || profileLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return <ProfileDashboard />;
};

export default Dashboard;